import * as _ from 'lodash';

import { ApplicationConfig } from '../../shared/applicationConfig';
import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

export class GalleryService {
    static defaultGallerySortConcept = 'dataPublicacio';

    static getAllElements() {
        return SharedService.httpGetElements(ApplicationConstants.getAllMapsUrl);
    }

    static getAllPublicsMaps() {
        return SharedService.httpGetElements(ApplicationConstants.getAllMapsUrl+"limit=-1");
    }

    static getNumGaleria() {
        return SharedService.httpGetElements(ApplicationConstants.getNumGaleria);
    }

    static getSearchMaps(q){
        return SharedService.httpGetElements(ApplicationConstants.searchGaleriaMaps+q);
    }

    static getMapsByUser(user){
        return SharedService.httpGetElements(ApplicationConstants.searchGaleriaMapsByUser+user);
	}
	
	static getMapsTipusApp(user, tipusApp){
        return SharedService.httpGetElements(ApplicationConstants.searchGaleriaApps+user+"&tipusApp="+tipusApp);
    }

    static loginUser(token){
        return SharedService.httpPost(ApplicationConstants.postLoginTokenUrl+token);
    }

    static getElements(elements, pageNumber, textToFilter, currentSortConcept, currentOrder, selectedSortConcept, paginating, sorting, totalPages) {
        let result = _.cloneDeep(elements);
        let numPages = 1;
        const sortOrder = GalleryService.getCurrentOrder(currentSortConcept, currentOrder, selectedSortConcept, sorting);
        result = _.orderBy(result, selectedSortConcept, sortOrder);

        if (textToFilter && textToFilter.length >= ApplicationConfig.minCharsToFilterText) {
            result = GalleryService.filterElements(textToFilter, result);
        }

        numPages = GalleryService.totalPagesNumber(result, totalPages);
        if (paginating) {
            if (pageNumber > numPages) {
                pageNumber = numPages;
            }
        } else {
            pageNumber = 1;
        }

        const numElements = result.length;
        result = GalleryService.pageElements(result, pageNumber);

        return {
            numPages,
            currentPage: pageNumber,
            numElements,
            elements: result,
            currentSortConcept: selectedSortConcept,
            currentOrder: sortOrder,
        };
    }

    static filterElements(textToFilter, elements) {
        return elements.filter((item) => {
            return (item && item.nomAplicacio && item.nomAplicacio.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1) ||
                (item && item.description && item.description.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1) ||
                (item && item.tags && item.tags.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1) ||
                (item && item.usuari && item.usuari.toLowerCase().indexOf(textToFilter.toLowerCase()) > -1);
        });
    }

    static getCurrentOrder(currentSortConcept, currentOrder, selectedSortConcept, sorting) {
        if (sorting) {
            if (currentSortConcept === selectedSortConcept) {
                return currentOrder === ApplicationConstants.ascendingOrder
                    ? ApplicationConstants.descendingOrder
                    : ApplicationConstants.ascendingOrder;
            }

            return ApplicationConfig.defaultSortOrder;
        }

        return currentOrder;
    }

    static totalPagesNumber(elements, totalPages) {
        totalPages = totalPages ? totalPages : elements.length;
        return elements
            ? Math.ceil(totalPages / ApplicationConfig.galleryElementsPerPage)
            : 0;
    }

    static pageElements(elements, pageNumber) {
        let sliced = elements.slice((pageNumber - 1) * ApplicationConfig.galleryElementsPerPage);
        return _.take(sliced, ApplicationConfig.galleryElementsPerPage);
    }

}



// WEBPACK FOOTER //
// ./src/gallery/services/galleryService.js